import DashboardSingleData from "../../model/DashboardSingeData";
import DashboardTabMediator from "./DashboardTabMediator";

export default class DashboardHealthSystemsTabMediator extends DashboardTabMediator {
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, dashboardNumberChartFactory) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._dashboardNumberChartFactory = dashboardNumberChartFactory;
        this._languagePack = languagePack;
        this._numberCharts = [];
    }

    initialize() {
        super.initialize();
        this._target.LabelTab2.text = this._languagePack.getText(`dashboard.healthSystemsTab.legendTab`);
        this._target.FirstCategoryTitleTextField.text = this._languagePack.getText(`dashboard.healthSystemsTab.firstCategory`);
        this._target.SecondCategoryTitleTextField.text = this._languagePack.getText(`dashboard.healthSystemsTab.secondCategory`);
        this._target.ThirdCategoryTitleTextField.text = this._languagePack.getText(`dashboard.healthSystemsTab.thirdCategory`);


        let dataSetNumbers = [

            new DashboardSingleData(this._languagePack.getText("dashboard.healthSystemsTab.numberCharts.numberConsultationsNonENV"), "16 000", 0, true, true),
            new DashboardSingleData(this._languagePack.getText("dashboard.healthSystemsTab.numberCharts.numberConsultationsPerHealthCaseWorker"), "115", 0, true, true),

            new DashboardSingleData(this._languagePack.getText("dashboard.healthSystemsTab.numberCharts.numberANCVisits"), "325", 0, true, true),
            new DashboardSingleData(this._languagePack.getText("dashboard.healthSystemsTab.numberCharts.numberDeliveriesPHC"), "118", 0, true, true),

            new DashboardSingleData(this._languagePack.getText("dashboard.healthSystemsTab.numberCharts.numberChildrenModerateAcuteMalnutrition"), "395", 0, true, false),
            new DashboardSingleData(this._languagePack.getText("dashboard.healthSystemsTab.numberCharts.numberChildrenUnder5Diarrhea"), "230", 0, true, false),
            new DashboardSingleData(this._languagePack.getText("dashboard.healthSystemsTab.numberCharts.numberChildrenUnderNonENVRespiratoryInfections"), "340", 0, true, false),
            new DashboardSingleData(this._languagePack.getText("dashboard.healthSystemsTab.numberCharts.percentChildrenDPT1"), "92%", 0, true, true)
        ];

        var self = this;
        dataSetNumbers.forEach(function (dashboardSingleData, index) {
            var numberChart = self._dashboardNumberChartFactory.createNumberChart(self._target["DataElement" + (index + 1)]);
            numberChart.setData(dashboardSingleData, false);
            self._numberCharts.push(numberChart);
        });
    }

    destroy() {
        super.destroy();
        for (let i = 0; i < this._numberCharts.length; i++) {
            const numberChart = this._numberCharts[i];
            numberChart.destroy();
        }

        this._numberCharts = [];
        this._target.removeAllChildren();
    }
    get skin() {
        return this._target;
    }

    get keyDecision() {
        return this._keyDecision;
    }
}